import { render, staticRenderFns } from "./DkWizardLeadFormTabs.vue?vue&type=template&id=0e3b0860&"
import script from "./DkWizardLeadFormTabs.vue?vue&type=script&lang=js&"
export * from "./DkWizardLeadFormTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports